<template>
    <BreadCrumb PageTitle="État des places avec Arriérés" />
    <EtatPlacesArrieres />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EtatPlacesArrieres from "../../components/Etats/EtatPlacesArrieres.vue";
  
    export default defineComponent({
      name: "EtatPlacesArrieresPage",
      components: {
        BreadCrumb,
        EtatPlacesArrieres,
      },
    });
  </script>
